import { Button } from '@mui/material';

export const RefreshPageButton = () => (
  <Button color="primary" size="small" onClick={() => window.location.reload()}>
    Refresh
  </Button>
);
